<template>
  <div class="mb-13">
    <h2 id="fund_education" class="text-h2">
      {{ $t('L_fund_children_education') }}
    </h2>
    <v-row class="d-flex align-center">
      <v-col cols="12" sm="8" md="9" id="fund_education" class="pt-4 pb-0">
        <h4 class="text-h4">
          {{ $t('L_provide_for_education') }}
        </h4>
      </v-col>
      <v-col cols="12" class="pl-1 pb-0">
        <LinkedSlider
          v-model="amount"
          :form-input="formInput"
          :tooltip-text="$t('L_education_average_cost')"
          max="100000"
          step="1000"
          @update:model-value="$emit('update:modelValue', $event)"
          @input="$emit('input', $event)"
          label-id="fund_education"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import Slider from '@/components/Inputs/Slider/Slider.vue';
import LinkedSlider from './LinkedSlider.vue';
import CurrencyDisplay from './CurrencyDisplay.vue';

const componentOptions: ComponentOptions = {
  name: 'FundEducation',
  components: {
    LinkedSlider,
    Slider,
    CurrencyDisplay,
  },
  data: () => ({
    amount: 57000,
    manualInput: false,
  }),
  props: {
    modelValue: {
      type: [Number, String],
      required: true,
    },
    formInput: {
      type: Object,
      required: true,
    },
  },
  watch: {
    modelValue(value) {
      this.amount = value;
    },
  },
  mounted() {
    this.amount = this.modelValue;
  },
};

export default defineComponent(componentOptions);
</script>
